module.exports = __webpack_public_path__ + "img/BIN.0df25e9d.svg";